class RevivewsCarousel extends HTMLElement {
  constructor() {
    super();

    this.isMouseenter = false;
    this.elements = {
      slider_element: this,
      slide_items: this.querySelectorAll('.swiper-slide')
    }
    this.init();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  onSectionLoad(event) {
    filterShopifyEvent(event, this, this.initSlider.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.initSlider.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.initSlider.bind(this));
  }

  init() {
    if (Shopify && Shopify.designMode) this.initSlider();
    setTimeout(() => this.initSlider());
  }

  setHeightSilde() {
    this.elements.slide_items.forEach(el => {
        const height = el.querySelector('.review__wrapper').offsetHeight;
        el.querySelector('.review__wrapper').style.setProperty('--item-height', height + 'px');
    });
  }

  setHeightSildeText() {
    this.elements.slide_items.forEach(el => {
      const heightText = el.querySelector('.review__text').offsetHeight;
      el.querySelector('.review__wrapper').style.setProperty('--item-text-height', heightText + 'px');
    });
  }

  initSlider() {
    var swiper = new Swiper(this.elements.slider_element, {
      spaceBetween: 8,
      slidesPerView: 1.5,
      centeredSlides: true,
      paginationClickable: true,
      roundLengths: false,
      freeMode: false,
      watchActiveIndex: true,
      slideToClickedSlide: true,
      loop: false,
      autoplay: true,
      speed: 500,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 8
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 8
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 8
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 1
        }
      },
      on: {
        init: (element) => {
          let centerIndex = parseInt(element.params.slidesPerView/2);
          element.slides.forEach((slide, index) => {
            slide.setAttribute('data-index', index);
          });
          element.slideTo(centerIndex);
        }
      }
    });
    //this.elements.slider_element.addEventListener('mouseenter', () => swiper.autoplay.stop());
    //this.elements.slider_element.addEventListener('mouseleave', () => swiper.autoplay.start());
    
    this.setHeightSilde();
    this.setHeightSildeText()
  }
}

customElements.define('reviews-carousel', RevivewsCarousel);